import { createActions } from "redux-actions";

const {
  dadataSearch,
  dadataSearchSuccess,
  dadataSearchFailure,
  dadataSet,
  dadataIdle,
  dadataClearSelected
} = createActions(
  "DADATA_SEARCH",
  "DADATA_SEARCH_SUCCESS",
  "DADATA_SEARCH_FAILURE",
  "DADATA_SET",
  "DADATA_IDLE",
  "DADATA_CLEAR_SELECTED",
);

export {
  dadataSearch,
  dadataSearchSuccess,
  dadataSearchFailure,
  dadataSet,
  dadataIdle,
  dadataClearSelected,
};
